export const isTargetTextInput = (targetEl: HTMLElement | null): boolean => {
  if (!targetEl) return false;

  if (targetEl.contentEditable === "true") return true;

  const tag = targetEl.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "CODE") return true;

  if (
    targetEl.closest('[data-generate-input="true"]') ||
    targetEl.closest(".monaco-editor") ||
    targetEl.closest("#tiptap-editor") ||
    targetEl.closest(".ProseMirror-trailingBreak")
  ) {
    return true;
  }

  return false;
};
